import React from 'react';
import { Form, Field } from 'react-final-form';
import propTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import { STRIP_HTML_TAGS, RANDOM_STRING } from '../../../../../../../../constants';

const userTasks = props => props.tasks.map(task => {
    const uniqueId = RANDOM_STRING(7);

    return (
        <div key={task.id} className="panel">
            <div className="panel-heading" id={STRIP_HTML_TAGS(task.task)} role="tab">
                <a className="panel-title" data-toggle="collapse" href={`#${uniqueId}`} data-parent="#taskAccordion" aria-expanded="false" aria-controls={task.id} style={{paddingBottom: 0}}>
                    {props.taskNameShortener(STRIP_HTML_TAGS(task.task))}
                </a>
            </div>
            <div className="panel-collapse collapse" id={uniqueId} aria-labelledby={task.task} role="tabpanel" style={{background: 'rgba(238, 238, 238, 1)', borderRadius: '5px'}}>
                <div className="panel-body" style={{margin: 'auto 4px'}}>
                    <div style={{marginBottom: '5px'}}>
                        <span style={{fontWeight: '700'}}>Task:</span> <strong>{STRIP_HTML_TAGS(task.task)}</strong>
                    </div>
                    <div style={{marginBottom: '5px'}}>
                        <span style={{fontWeight: '700'}}>Due:</span> <span style={{color: '#ff9800'}}>{task.due_date}</span>
                    </div>
                    <Form onSubmit={action_data => props.taskActionHandler(task.id, action_data, 'user')} initialValues={{completed: false}} render={({handleSubmit, form, submitting, pristine, values}) => (
                        <form autoComplete="off" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <div className="input-group">
                                    <Field type="text" className="form-control" name="action" component="input" placeholder="Action taken..." required />
                                    <div className="input-group-append">
                                        <div className="input-group-text" data-tip="Completed" data-place="top" data-effect="solid" style={{backgroundColor: '#eeeeee'}}>
                                            <span className="checkbox-custom checkbox-success">
                                                <Field type="checkbox" id={uniqueId} name="completed" className="form-control" component="input" />
                                                <label htmlFor={uniqueId}></label>
                                                <ReactTooltip />
                                            </span>
                                        </div>
                                        <button type="submit" className="btn btn-animate btn-animate-vertical btn-primary btn-sm waves-effect waves-classic btn-round btn-pill-right" tabIndex="-1" disabled={submitting || pristine}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                        </form>
                    )}/>
                </div>
            </div>
        </div>
    );
});

userTasks.propTypes = {
    tasks: propTypes.array,
    taskNameShortener: propTypes.func,
    taskActionHandler: propTypes.func
};

export default userTasks;